export default "__VITE_ASSET__D45$iwUJ__"